export const InfoTooltip = {
  parts: ['Icon', 'Tooltip'],
  baseStyle: {
    Icon: {
      textAlign: 'center',
      color: 'brand.lightgrey',
      fontSize: '22px',
    },
    GlobalIcon: {
      color: 'brand.green',
      width: '55px',
      height: '55px',
      marginRight: '12px',
    },
    Tooltip: {
      display: 'inline-block',
      fontSize: '14px',
      color: 'brand.black',
      padding: '10px 20px',
      borderRadius: '15px',
      background: 'brand.lightgreen2',
    },
  },
};
